import { withProperties } from '$/utils/type';
import styled from '@emotion/styled';
import tw, { TwStyle } from 'twin.macro';

const getCardSize = (size?: 'small' | 'xs' | 'md' | 'lg'): string => {
  switch (size) {
    case 'xs':
      return `width: 6rem; height: 4rem;`;
    case 'small':
      return `width: 10rem; height: 6rem;`;
    case 'md':
      return `
        width: 14rem; height: 8rem;
      `;
    case 'lg':
    default:
      return `
        width: 15rem; height: 8rem;
        @media screen and (min-width: 920px) {
          width: 17rem; height: 10rem;
        }
      `;
  }
};

const smallTextSize = {
  xs: 'font-size: 0.75rem;',
  small: 'font-size: 875rem;',
  md: 'font-size: 1rem;',
  lg: 'font-size: 1rem;',
};

const lgTextSize = {
  xs: 'font-size: 1.25rem;',
  small: 'font-size: 1.375rem;',
  md: `
    font-size: 1.5rem;
    @media screen and (min-width: 920px) {
      font-size: 1.75rem;
    }
  `,
  lg: `
    font-size: 1.5rem;
    @media screen and (min-width: 920px) {
      font-size: 1.75rem;
    }
  `,
};

const Colored = styled.div<{ color?: string }>`
  ${({ color }): string => (color ? `color: ${color} !important` : '')}
`;

const CardTitle = styled(Colored)`
  ${tw`text-center uppercase text-sm md:text-base`}
`;

const CardContent = styled(Colored)`
  ${tw`flex flex-row items-center relative font-normal`}
`;

const SubContent = styled(Colored)`
  ${tw`text-md text-center leading-4 text-gray-600`}
`;

const CardCTAButton = styled(SubContent)<{ disabled?: boolean }>`
  ${tw`text-color-brand hover:text-color-brandLight underline cursor-pointer`}
  ${({ disabled }): TwStyle | string => (disabled ? tw`opacity-disabled cursor-not-allowed` : '')}
`;

const CardComponent = styled.div<{
  inverted?: boolean;
  size?: 'xs' | 'small' | 'md' | 'lg';
}>`
  ${tw`flex flex-col relative justify-start items-center rounded-xl overflow-hidden leading-loose bg-white shadow-sm`}
  line-height: 1rem;
  padding: 0.75rem 0.5rem;
  @media screen and (min-width: 920px) {
    padding: 1.25rem 0.5rem;
  }
  justify-content: space-between;
  ${({ size }): string => getCardSize(size ?? 'lg')}
  ${({ size }): string => `${smallTextSize[size ?? 'lg']}`}
  ${CardTitle} {
    ${({ inverted }): TwStyle => (inverted ? tw`text-white` : tw`text-gray-700`)}
    padding-bottom: 0.25rem;
  }
  ${CardContent} {
    text-align: center;
    ${({ size }): string => `${lgTextSize[size ?? 'lg']}`}
    ${({ size }): string => `line-height: ${size === 'xs' ? '1' : '1.25'};`}
    ${({ inverted }): TwStyle => (inverted ? tw`text-gray-200` : tw`text-gray-700`)}
  }
`;

export const Card = withProperties(CardComponent, {
  Title: CardTitle,
  Content: CardContent,
  SubContent: SubContent,
  CTA: CardCTAButton,
});
